<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-12">
                <div class="d-flex flex-wrap flex-wrap align-items-center justify-content-between mb-4">
                    <div>
                        <h4 class="mb-3">통합 구매 요청</h4>
                        <p class="mb-0">바코드, SKU ID, 옵션ID를 입력하여 자동으로 그로스/로켓 상품을 매칭합니다.<br>
                        ★ 현재는 1688링크만 구매 가능합니다.(다른 링크의 경우 쿠패스 채널톡으로 문의해 주세요)<br>
                        구매요청 후에는 반드시 쿠패스 채널톡으로 말씀해주세요. 구매현황 및 기타문의는 쿠패스 채널톡을 이용해 주세요 ----> 
                        <a href="http://pf.kakao.com/_AxcWvxj" target="_blank"><u>쿠패스 전용 채널톡 바로가기</u></a></p>
                    </div>
                </div>

                <b-modal id="modal-2" size="xl" title="견적서" ok-only>
                    <div class="text-center">
                        <h3 class="mb-2">적용 회원등급 : {{ $store.state.user.grade.toUpperCase() }}</h3>
                        <img style="max-width:100%;" :src="require('../../../assets/images/small/견적서.jpg')">
                    </div>
                </b-modal>

                <tab-nav :tabs="true" id="myTab-1">
                    <tab-nav-items :active="true" id="req-tab" ariaControls="req" role="tab" :ariaSelected="true"
                        title="구매대행요청" />
                    <tab-nav-items :active="false" id="list-tab" ariaControls="list" role="tab" :ariaSelected="false"
                        title="구매대행요청내역" />
                </tab-nav>

                <tab-content id="myTabContent">
                    <tab-content-item :active="true" id="req" aria-labelled-by="req-tab">

                        <div class="row" v-if="showlist">
                            <div class="col-12">
                                <div class="table-responsive">
                                    <table id="datatable" class="table data-table table-striped dataTable">
                                        <thead>
                                            <tr class="ligth ligth-data">
                                                <th>
                                                    <div class="checkbox d-inline-block">
                                                        <input type="checkbox" class="checkbox-input" id="checkbox1"
                                                            v-model="allchecked" @change="allchecklist(allchecked)">
                                                        <label for="checkbox1" class="mb-0"></label>
                                                    </div>
                                                </th>
                                                <th style="min-width:200px;">제품정보</th>
                                                <th>상품매칭</th>
                                                <th style="max-width:300px;overflow:hidden;text-overflow: ellipsis;">
                                                    구매링크</th>
                                                <th>옵션1_중국어</th>
                                                <th>옵션2_중국어</th>
                                                <th>구매재고</th>
                                                <th>요청사항</th>
                                                <th>구매요청수량</th>
                                                <th>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(list, index) in lists" :key="index">
                                                <td>
                                                    <div class="checkbox d-inline-block">
                                                        <input type="checkbox" class="checkbox-input" :id="'checkbox' + index"
                                                            v-model="list.checked">
                                                        <label :for="'checkbox' + index" class="mb-0"></label>
                                                    </div>
                                                </td>

                                                <td style="min-width:200px;">
                                                    <div class="d-flex align-items-center">
                                                        <img :src="list.등록이미지" class="img-fluid rounded avatar-80 mr-3"
                                                            alt="image" v-if="list.등록이미지">
                                                        <div v-if="list.상품명">
                                                            {{ list.상품명 }}
                                                            <p class="mb-0"><small>{{ list.식별자타입 }}: {{ list.바코드 }}</small></p>
                                                            <p class="mb-0" v-if="list.매칭시스템">
                                                                <span class="badge badge-info">{{ list.매칭시스템 }}</span>
                                                            </p>
                                                        </div>
                                                        <div v-else>
                                                            <input type="text" class="form-control" placeholder="상품명입력"
                                                                v-model="list.상품명init" @change="addProductName(list)">
                                                            <p class="mb-0"><small>{{ list.식별자타입 }}: {{ list.바코드 }}</small></p>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div :class="matchclass(list.매칭상태)">{{ list.매칭상태 }}</div>
                                                </td>
                                                <td style="max-width:300px;overflow:hidden;text-overflow: ellipsis;">
                                                    <div v-if="list.구매링크 !== undefined">
                                                        <a :href="list.구매링크" target="_blank">{{ list.구매링크 }}</a>
                                                        <div v-if="list.showspinner">
                                                            <img style="width:20%;"
                                                                :src="require('../../../assets/images/small/loading.gif')">
                                                        </div>
                                                    </div>
                                                    <div v-else>
                                                        <input type="text" class="form-control" placeholder="구매링크입력"
                                                            v-model="list.구매링크init" @change="matchoption1(index, list.구매링크init)">
                                                    </div>
                                                </td>
                                                <td>
                                                    <div v-if="list.상품매칭 && list.상품매칭.옵션1_중국어 && list.상품매칭.옵션1_중국어.length > 0">
                                                        <button class="btn btn-sm btn-outline-primary" 
                                                            v-for="(a, aindex) in list.상품매칭.옵션1_중국어" :key="aindex"
                                                            @click="option1matching(a, list)">
                                                            🔍 {{ a.name }}
                                                        </button>
                                                    </div>
                                                    <div v-else>
                                                        <button class="btn btn-sm btn-outline-secondary">🔍 Search</button>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div v-if="list.상품매칭 && list.상품매칭.옵션2_중국어 && list.상품매칭.옵션2_중국어.length > 0">
                                                        <button class="btn btn-sm btn-outline-primary" 
                                                            v-for="(b, bindex) in list.상품매칭.옵션2_중국어" :key="bindex"
                                                            @click="option2matching(b, list)">
                                                            🔍 {{ b.name }}
                                                        </button>
                                                    </div>
                                                    <div v-else>
                                                        <button class="btn btn-sm btn-outline-secondary">🔍 Search</button>
                                                    </div>
                                                </td>
                                                <td>{{ list.구매재고 || 0 }}</td>
                                                <td>{{ list.요청사항 || '요청등록' }}</td>
                                                <td>
                                                    <input type="number" class="form-control" style="width: 80px;" 
                                                        v-model="list.구매요청수량" min="1">
                                                </td>
                                                <td>
                                                    <div class="d-flex">
                                                        <a class="badge bg-success mr-2 reqpo-action-button" 
                                                            href="javascript:void(0)" @click="editItem(list, index)">
                                                            <i class="ri-edit-line mr-0"></i>
                                                        </a>
                                                        <a class="badge bg-warning mr-2 reqpo-action-button" 
                                                            href="javascript:void(0)" @click="deletelist(list)">
                                                            <i class="ri-delete-bin-line mr-0"></i>
                                                        </a>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="text-center">
                                                    <button @click="addlists" class="btn btn-outline-primary">+</button>
                                                </td>
                                                <td colspan="2">
                                                    <input type="text" class="form-control"
                                                        placeholder="바코드, SKU ID, 옵션ID 입력" 
                                                        @keyup.enter="addlists"
                                                        v-model="추가바코드">
                                                </td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="mt-3">
                                    <button type="button" class="btn btn-primary mr-2" @click="requestpurchase">구매대행요청</button>
                                    <button type="button" class="btn btn-secondary mr-2" @click="savereqlist">현재상태저장</button>
                                    <button type="button" class="btn btn-info mr-2" @click="bulkOrder">대량주문</button>
                                </div>
                            </div>
                        </div>
                    </tab-content-item>

                    <tab-content-item :active="false" id="list" aria-labelled-by="list-tab">
                        <card>
                            <div class="p-3">
                                <form @submit.prevent="submit">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="custom-control custom-radio custom-control-inline">
                                                <input type="radio" id="customRadio7" name="customRadio-2"
                                                    class="custom-control-input" v-model="selectdate" value="today"
                                                    @change="changedate()">
                                                <label class="custom-control-label" for="customRadio7">오늘</label>
                                            </div>
                                            <div class="custom-control custom-radio custom-control-inline">
                                                <input type="radio" id="customRadio8" name="customRadio-2"
                                                    class="custom-control-input" v-model="selectdate" value="week"
                                                    @change="changedate()">
                                                <label class="custom-control-label" for="customRadio8">최근7일</label>
                                            </div>
                                            <div class="custom-control custom-radio custom-control-inline">
                                                <input type="radio" id="customRadio9" name="customRadio-2"
                                                    class="custom-control-input" v-model="selectdate" value="month"
                                                    @change="changedate()">
                                                <label class="custom-control-label" for="customRadio9">최근1개월</label>
                                            </div>
                                        </div>
                                        <div class="col-md-12 mt-2">
                                            <b-input-group>
                                                <select class="custom-select col-md-2" style="height:40px"
                                                    v-model="selectoption">
                                                    <option>요청일</option>
                                                </select>
                                                <b-form-datepicker id="example-datepicker1" size="sm"
                                                    v-model="startdate" class="mb-2"></b-form-datepicker>
                                                <p>~</p>
                                                <b-form-datepicker id="example-datepicker2" size="sm" v-model="enddate"
                                                    class="mb-2"></b-form-datepicker>
                                            </b-input-group>
                                        </div>
                                        <div class="col-md-4">
                                            <div class="form-group">
                                                <input type="text" class="form-control" placeholder="상품명" v-model="상품명">
                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            <div class="form-group">
                                                <input type="text" class="form-control" placeholder="바코드" v-model="바코드">
                                            </div>
                                        </div>
                                    </div>
                                    <button type="button" class="btn btn-primary mr-2 mt-1" @click="search">검색</button>
                                    <img v-if="showspinner" style="max-width:100%;"
                                        :src="require('../../../assets/images/small/spinner.gif')">
                                </form>
                            </div>
                        </card>

                        <div class="col-lg-12" v-if="showreqlist">
                            <div class="p-3">
                                <div class="row">
                                    <b-button variant="outline-primary" class="mb-1 mr-2" @click="showtotal">
                                        전체 <b-badge variant="primary" class="ml-2">{{ total }}</b-badge>
                                    </b-button>
                                </div>
                            </div>

                            <!-- CDataTable로 구매대행요청내역 표시 -->
                            <CDataTable
                                storage-key="unifiedPurchaseRequestV2"
                                :headers="historyHeaders"
                                :items="reqlists"
                                v-model="tableSelectedItem"
                                :show-select="true"
                                itemKey="_id">

                                <!-- 상품정보 컬럼 -->
                                <template v-slot:상품정보="{ item }">
                                    <div class="d-flex align-items-center" style="min-width:200px;">
                                        <img :src="item.등록이미지" class="img-fluid rounded avatar-60 mr-2"
                                            alt="image" v-if="item.등록이미지">
                                        <div>
                                            <div class="font-weight-bold">{{ item.상품명 }}</div>
                                            <small class="text-muted">{{ item.바코드 }}</small>
                                            <div v-if="item.reqtype">
                                                <span class="badge badge-info">{{ item.reqtype }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </template>

                                <!-- 구매링크 컬럼 -->
                                <template v-slot:구매링크="{ item }">
                                    <div style="max-width:250px;overflow:hidden;text-overflow: ellipsis;">
                                        <a :href="item.구매링크" target="_blank" v-if="item.구매링크">
                                            {{ item.구매링크 }}
                                        </a>
                                        <span v-else class="text-muted">-</span>
                                    </div>
                                </template>

                                <!-- 요청일시 컬럼 -->
                                <template v-slot:요청일시="{ item }">
                                    {{ formatDate(item.요청일) }}
                                </template>

                                <!-- 수량 컬럼 -->
                                <template v-slot:수량="{ item }">
                                    {{ item.구매요청수량 || '-' }}
                                </template>

                                <!-- 진행현황 컬럼 -->
                                <template v-slot:진행현황="{ item }">
                                    <span :class="getStatusClass(item.진행현황)">
                                        {{ item.진행현황 || '구매전' }}
                                    </span>
                                </template>

                                <!-- 요청사항 컬럼 -->
                                <template v-slot:요청사항="{ item }">
                                    <button class="btn btn-sm btn-outline-info" @click="viewRequirement(item)">
                                        {{ item.요청사항 || '요청등록' }}
                                    </button>
                                </template>
                            </CDataTable>
                        </div>
                    </tab-content-item>
                </tab-content>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import { validationMixin } from 'vuelidate'
import { required, integer } from 'vuelidate/lib/validators'
import CDataTable from "@/components/common/CDataTable";

export default {
    name: 'UnifiedPurchaseRequestV2',
    components: {
        CDataTable
    },
    mixins: [validationMixin],
    validations: {
        lists: {
            $each: {
                구매요청수량: { required, integer }
            }
        }
    },
    data() {
        return {
            title: '통합 구매 요청',
            desc1: '바코드, SKU ID, 옵션ID를 입력하여 자동으로 그로스/로켓 상품을 매칭합니다.',
            desc2: '★ 현재는 1688링크만 구매 가능합니다.(다른 링크의 경우 쿠패스 채널톡으로 문의해 주세요)',
            desc3: '구매요청 후에는 반드시 쿠패스 채널톡으로 말씀해주세요. 구매현황 및 기타문의는 쿠패스 채널톡을 이용해 주세요',
            
            lists: [],
            추가바코드: '',
            showlist: true,
            allchecked: false,
            
            // 구매대행요청내역 관련
            reqlists: [],
            showreqlist: false,
            startdate: '',
            enddate: '',
            상품명: '',
            바코드: '',
            selectdate: 'month',
            selectoption: '요청일',
            showspinner: false,
            total: 0,
            구매전: 0,
            구매확인: 0,
            tableSelectedItem: [],

            historyHeaders: [
                { text: '상품정보', value: '상품정보', width: '250px', isSlot: true },
                { text: '구매링크', value: '구매링크', width: '250px', isSlot: true },
                { text: '요청일시', value: '요청일시', width: '150px', isSlot: true },
                { text: '수량', value: '수량', width: '80px', isSlot: true },
                { text: '진행현황', value: '진행현황', width: '120px', isSlot: true },
                { text: '요청사항', value: '요청사항', width: '120px', isSlot: true }
            ]
        }
    },
    mounted() {
        this.getreqlists()
        
        // 기본 날짜 설정 (최근 30일)
        const today = new Date()
        const thirtyDaysAgo = new Date(today.getTime() - (30 * 24 * 60 * 60 * 1000))
        
        this.enddate = today.toISOString().split('T')[0]
        this.startdate = thirtyDaysAgo.toISOString().split('T')[0]
    },
    methods: {
        getreqlists() {
            this.showlist = false;
            this.lists = [];
            axios.post('/api/reqpurchase/getreqlist', [])
                .then((res) => {
                    if (res.data.notifyData) {
                        const lastClosed = localStorage.getItem('modalClosedDate');
                        const today = new Date().toISOString().split('T')[0];

                        if (lastClosed !== today) {
                            this.isNotify = true;
                        }
                        this.notifyData = res.data.notifyData
                    }
                    if (res.data.lists || res.data.lists == []) {
                        res.data.lists.forEach(e => {
                            // 모든 타입의 구매요청을 포함 (제트배송, 샘플검증, 로켓배송)
                            if (e) {
                                e.요청내역 = e.요청내역 || {};
                                e.요청내역.destination = e.요청내역 && e.요청내역.destination ? e.요청내역.destination : 'coupang';
                                e.요청내역.customsType = e.요청내역 && e.요청내역.customsType ? e.요청내역.customsType : 'integrated';
                                e.요청내역.reqcontentPurchase = e.요청내역?.reqcontentPurchase || '';
                                this.lists.push(e)
                            }
                        })
                        this.showlist = true;
                    } else {
                        alert(res.data.요청결과)
                        this.showlist = true;
                    }
                })
                .catch(console.log)
        },

        savereqlist() {
            axios.post('/api/reqpurchase/savereqlist', this.lists)
                .then((res) => {
                    alert(res.data.요청결과);
                })
                .catch(console.log)
        },

        addProductName(list) {
            list.상품명 = list.상품명init;
        },

        async addlists() {
            if (!this.추가바코드.trim()) {
                alert('입력값이 필요합니다.')
                return
            }

            const identifier = this.추가바코드.trim()

            // 식별자 타입 판별 및 매칭
            const matchResult = await this.matchProductByIdentifier(identifier)

            const newItem = {
                _id: Date.now().toString(),
                바코드: identifier,
                식별자타입: matchResult.type,
                매칭시스템: matchResult.system,
                상품명: matchResult.productName || null,
                상품명init: '',
                등록이미지: matchResult.image || '',
                매칭상태: matchResult.status,
                구매링크: undefined,
                구매링크init: '',
                상품매칭: {
                    옵션1_중국어: [],
                    옵션2_중국어: []
                },
                구매재고: 0,
                요청사항: '요청등록',
                구매요청수량: 1,
                checked: false,
                vendorItemId: matchResult.vendorItemId,
                productId: matchResult.productId,
                showspinner: false,
                reqtype: '통합구매'
            }

            this.lists.push(newItem)
            this.showlist = true
            this.추가바코드 = ''
        },

        async matchProductByIdentifier(identifier) {
            try {
                // 1. 옵션ID (vendorItemId) 체크 - growthdb에서 검색
                if (identifier.length >= 8 && /^\d+$/.test(identifier)) {
                    const growthResult = await this.searchInGrowthDb(identifier)
                    if (growthResult.found) {
                        return {
                            type: '옵션ID',
                            system: '로켓그로스',
                            status: '매칭완료',
                            productName: growthResult.productName,
                            image: growthResult.image,
                            vendorItemId: identifier,
                            productId: growthResult.productId
                        }
                    }
                }

                // 2. 바코드 체크 - growthdb에서 검색
                const barcodeResult = await this.searchByBarcode(identifier)
                if (barcodeResult.found) {
                    return {
                        type: '바코드',
                        system: barcodeResult.system,
                        status: '매칭완료',
                        productName: barcodeResult.productName,
                        image: barcodeResult.image,
                        vendorItemId: barcodeResult.vendorItemId,
                        productId: barcodeResult.productId
                    }
                }

                // 3. SKU ID 체크 - productdb에서 검색
                const skuResult = await this.searchBySku(identifier)
                if (skuResult.found) {
                    return {
                        type: 'SKU ID',
                        system: '로켓배송',
                        status: '매칭완료',
                        productName: skuResult.productName,
                        image: skuResult.image,
                        vendorItemId: skuResult.vendorItemId,
                        productId: skuResult.productId
                    }
                }

                // 매칭 실패
                return {
                    type: '미확인',
                    system: '매칭실패',
                    status: '매칭실패',
                    productName: '',
                    image: ''
                }

            } catch (error) {
                console.error('상품 매칭 오류:', error)
                return {
                    type: '오류',
                    system: '시스템오류',
                    status: '매칭오류',
                    productName: '',
                    image: ''
                }
            }
        },

        async searchInGrowthDb(vendorItemId) {
            try {
                const response = await axios.post('/api/growth/searchByVendorItemId', {
                    vendorItemId: vendorItemId
                })

                if (response.data && response.data.length > 0) {
                    const product = response.data[0]
                    return {
                        found: true,
                        productName: product.productName,
                        image: product.등록이미지,
                        vendorItemId: product.vendorItemId,
                        productId: product.productId
                    }
                }
                return { found: false }
            } catch (error) {
                console.error('GrowthDB 검색 오류:', error)
                return { found: false }
            }
        },

        async searchByBarcode(barcode) {
            try {
                // growthdb에서 바코드 검색
                const growthResponse = await axios.post('/api/growth/searchByBarcode', {
                    barcode: barcode
                })

                if (growthResponse.data && growthResponse.data.length > 0) {
                    const product = growthResponse.data[0]
                    return {
                        found: true,
                        system: '로켓그로스',
                        productName: product.productName,
                        image: product.등록이미지,
                        vendorItemId: product.vendorItemId,
                        productId: product.productId
                    }
                }

                // productdb에서 바코드 검색
                const productResponse = await axios.post('/api/product/searchByBarcode', {
                    barcode: barcode
                })

                if (productResponse.data && productResponse.data.length > 0) {
                    const product = productResponse.data[0]
                    return {
                        found: true,
                        system: '로켓배송',
                        productName: product.productName,
                        image: product.등록이미지,
                        vendorItemId: product.vendorItemId,
                        productId: product.productId
                    }
                }

                return { found: false }
            } catch (error) {
                console.error('바코드 검색 오류:', error)
                return { found: false }
            }
        },

        async searchBySku(sku) {
            try {
                const response = await axios.post('/api/product/searchBySku', {
                    sku: sku
                })

                if (response.data && response.data.length > 0) {
                    const product = response.data[0]
                    return {
                        found: true,
                        productName: product.productName,
                        image: product.등록이미지,
                        vendorItemId: product.vendorItemId,
                        productId: product.productId
                    }
                }
                return { found: false }
            } catch (error) {
                console.error('SKU 검색 오류:', error)
                return { found: false }
            }
        },

        matchclass(a) {
            if (a == '매칭완료') {
                return 'badge badge-success';
            } else {
                return 'badge badge-warning';
            }
        },

        allchecklist(allchecked) {
            if (allchecked == true) {
                this.lists.forEach(e => {
                    e.checked = true;
                })
            } else {
                this.lists.forEach(e => {
                    e.checked = false;
                })
            }
        },

        deletelist(item) {
            console.log(item)
            if (item.진행현황 === '구매전') {
                const index = this.reqlists.findIndex(i => i === item);
                if (index > -1) {
                    this.reqlists.splice(index, 1);
                }
            } else {
                alert('구매전 상태가 아닌 항목은 삭제할 수 없습니다.');
            }

            // 메인 리스트에서도 삭제
            var newarr = [];
            this.lists.forEach(e => {
                if (e !== item) {
                    newarr.push(e);
                }
            })
            this.lists = newarr;
        },

        async requestpurchase() {
            var list = await this.confirmlists(false)
            if (list.length == 0) {
                alert('요청할 목록이 없습니다.')
                return
            }

            var arr = [];
            var cnt = 0;
            var now = new Date().getTime();

            list.forEach(e => {
                cnt++;
                var obj = e;
                obj.요청일 = now;
                obj.구매_id = '';
                arr.push(this.deepClone(obj));
            })

            if (confirm("총 " + cnt + "건을 구매대행 요청하시겠습니까?")) {
                axios.post('/api/reqpurchase/requestpurchase', arr)
                    .then((res) => {
                        this.$store.commit('reqpurchaseupdate', res.data.reqpurchase);
                        alert(res.data.요청결과)
                        var ar = this.lists.filter(e => !e.checked)
                        this.lists = ar;
                        if (this.lists.length == 0) {
                            this.showlist = false;
                        }
                    })
                    .catch(console.log)
            }
        },

        async confirmlists(isAll) {
            var list = [];
            if (isAll) {
                list = this.lists;
            } else {
                list = this.lists.filter(e => e.checked);
            }

            if (list.length == 0) {
                return [];
            }

            // 유효성 검사
            for (let item of list) {
                if (!item.상품명) {
                    alert('상품명이 입력되지 않은 항목이 있습니다.');
                    return [];
                }
                if (!item.구매링크) {
                    alert('구매링크가 입력되지 않은 항목이 있습니다.');
                    return [];
                }
                if (!item.구매요청수량 || item.구매요청수량 <= 0) {
                    alert('구매요청수량이 올바르지 않은 항목이 있습니다.');
                    return [];
                }
            }

            return list;
        },

        deepClone(obj) {
            return JSON.parse(JSON.stringify(obj));
        },

        editItem(list, index) {
            // 편집 기능 구현
            console.log('편집:', list, index);
        },

        bulkOrder() {
            // 대량주문 기능 구현
            console.log('대량주문');
        },

        // 구매대행요청내역 관련 메서드들
        changedate() {
            const today = new Date();
            const todayStr = today.toISOString().split('T')[0];

            if (this.selectdate === 'today') {
                this.startdate = todayStr;
                this.enddate = todayStr;
            } else if (this.selectdate === 'week') {
                const weekAgo = new Date(today.getTime() - (7 * 24 * 60 * 60 * 1000));
                this.startdate = weekAgo.toISOString().split('T')[0];
                this.enddate = todayStr;
            } else if (this.selectdate === 'month') {
                const monthAgo = new Date(today.getTime() - (30 * 24 * 60 * 60 * 1000));
                this.startdate = monthAgo.toISOString().split('T')[0];
                this.enddate = todayStr;
            }
        },

        search() {
            this.showreqlist = false;
            this.reqlists = [];
            this.showspinner = true;

            const start = this.gettimestamp(this.startdate);
            const end = this.gettimestamp(this.enddate) + (1000 * 60 * 60 * 24) - 1;

            axios.post('/api/reqpurchase/getlists', {
                start: start,
                end: end,
                상품명: this.상품명,
                바코드: this.바코드
            })
            .then((res) => {
                this.showspinner = false;
                console.log('구매대행요청내역 조회 결과:', res.data.요청결과);

                if (res.data.reqpurchase && res.data.reqpurchase.length > 0) {
                    // 모든 타입의 구매요청 포함 (제트배송, 샘플검증, 로켓배송, 통합구매)
                    this.reqlists = res.data.reqpurchase.map(item => {
                        return {
                            ...item,
                            _id: item._id || Date.now() + Math.random(),
                            진행현황: item.진행현황 || '구매전',
                            checked: false
                        }
                    });
                    this.showreqlist = true;
                    this.calculateTotals();
                } else {
                    this.showreqlist = true;
                    alert('조회된 구매대행요청내역이 없습니다.');
                }
            })
            .catch((error) => {
                this.showspinner = false;
                console.error('구매대행요청내역 조회 실패:', error);
                alert('구매대행요청내역 조회에 실패했습니다.');
            });
        },

        gettimestamp(date) {
            return new Date(date).getTime();
        },

        formatDate(timestamp) {
            if (!timestamp) return '-';
            const date = new Date(timestamp);
            return date.toLocaleDateString('ko-KR') + ' ' + date.toLocaleTimeString('ko-KR', {
                hour: '2-digit',
                minute: '2-digit'
            });
        },

        getStatusClass(status) {
            const statusClasses = {
                '구매전': 'badge badge-secondary',
                '구매중': 'badge badge-warning',
                '구매확인': 'badge badge-info',
                '배송중': 'badge badge-info',
                '입고완료': 'badge badge-success',
                '취소': 'badge badge-danger',
                '배송지연예정': 'badge badge-warning',
                '발송완료': 'badge badge-info'
            };
            return statusClasses[status] || 'badge badge-light';
        },

        viewRequirement(item) {
            const requirement = item.요청사항 || '요청사항 없음';
            const reqContent = item.요청내역?.reqcontent || '';
            const reqContentPurchase = item.요청내역?.reqcontentPurchase || '';

            let message = `요청사항: ${requirement}`;
            if (reqContent) {
                message += `\n\n추가 요청사항: ${reqContent}`;
            }
            if (reqContentPurchase) {
                message += `\n\n구매 요청사항: ${reqContentPurchase}`;
            }

            alert(message);
        },

        calculateTotals() {
            this.total = this.reqlists.length;
            this.구매전 = this.reqlists.filter(item => item.진행현황 === '구매전').length;
            this.구매확인 = this.reqlists.filter(item => item.진행현황 === '구매확인' || item.진행현황 === '구매중').length;
        },

        showtotal() {
            // 전체 목록 표시
            this.search();
        },

        filterByStatus(status) {
            // 상태별 필터링
            if (status === '구매전') {
                this.reqlists = this.reqlists.filter(item => item.진행현황 === '구매전');
            } else if (status === '구매확인') {
                this.reqlists = this.reqlists.filter(item => item.진행현황 === '구매확인' || item.진행현황 === '구매중');
            }
        },

        submit() {
            // 폼 제출 방지
            return false;
        }
    }
}
</script>
